export function encodeAsBase64(stringToEncode: string) {
    if (typeof document === 'undefined') {
        return Buffer.from(stringToEncode).toString('base64');
    }

    return btoa(stringToEncode);
}
